(() => {
  const init = (section) => {
    if (section.dataset.carouselReady === 'true') return;
    const viewport = section.querySelector('[data-carousel-viewport]');
    const track = section.querySelector('[data-carousel-track]');
    const pagination = section.querySelector('[data-carousel-pagination]');
    const cards = [...section.querySelectorAll('[data-carousel-card]')].filter((card) => getComputedStyle(card).display !== 'none');
    if (!viewport || !track || !pagination || !cards.length) return;
    const syncInfoSlots = () => {
      cards.forEach((card) => {
        const title = card.querySelector('.bevanup-new-arrivals__details a');
        if (!title) return;
        card.style.setProperty('--bevanup-info-slot-height', Math.max(34, title.offsetHeight) + 'px');
      });
    };
    section.dataset.carouselReady = 'true';
    section.querySelectorAll('.bevanup-new-arrivals__image').forEach((image) => {
      const secondary = image.querySelector('.bevanup-new-arrivals__media--secondary');
      if (!secondary) return;
      let pointerInside = false;
      const revealSecondary = () => {
        if (secondary.complete && secondary.naturalWidth > 0) {
          image.classList.add('is-secondary');
          return;
        }
        secondary.loading = 'eager';
        secondary.addEventListener('load', () => {
          if (pointerInside || image.dataset.touchActivated === 'true') image.classList.add('is-secondary');
        }, { once: true });
      };
      image.addEventListener('pointerenter', () => {
        if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        pointerInside = true;
        revealSecondary();
      });
      image.addEventListener('pointerleave', () => {
        pointerInside = false;
        if (image.dataset.touchActivated !== 'true') image.classList.remove('is-secondary');
      });
    });
    let pageCount = 1;
    let activePage = 0;
    let scrollTimer;
    const cardsPerPage = () => 4;
    const pageOffset = (page) => {
      const card = cards[Math.min(page * cardsPerPage(), cards.length - 1)];
      return Math.min(
        Math.max(0, viewport.scrollWidth - viewport.clientWidth),
        Math.max(0, card.offsetLeft - track.offsetLeft)
      );
    };
    const renderDots = () => {
      pageCount = Math.ceil(cards.length / cardsPerPage());
      activePage = Math.min(activePage, pageCount - 1);
      pagination.innerHTML = '';
      for (let index = 0; index < pageCount; index += 1) {
        const dot = document.createElement('button');
        dot.className = 'bevanup-new-arrivals__dot';
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Page ' + (index + 1));
        dot.setAttribute('aria-current', String(index === activePage));
        dot.addEventListener('click', () => viewport.scrollTo({ left: pageOffset(index), behavior: 'smooth' }));
        pagination.append(dot);
      }
    };
    const syncDots = () => {
      const offsets = Array.from({ length: pageCount }, (_, index) => pageOffset(index));
      activePage = offsets.reduce((nearest, offset, index) => Math.abs(offset - viewport.scrollLeft) < Math.abs(offsets[nearest] - viewport.scrollLeft) ? index : nearest, 0);
      [...pagination.children].forEach((dot, index) => dot.setAttribute('aria-current', String(index === activePage)));
    };
    syncInfoSlots();
    renderDots();
    viewport.addEventListener('scroll', () => { window.clearTimeout(scrollTimer); scrollTimer = window.setTimeout(syncDots, 50); }, { passive: true });
    window.addEventListener('resize', () => { const previous = activePage; syncInfoSlots(); renderDots(); viewport.scrollTo({ left: pageOffset(previous), behavior: 'instant' }); syncDots(); });
  };
  const install = () => document.querySelectorAll('[data-bevanup-new-arrivals]').forEach(init);
  install();
  window.addEventListener('load', install, { once: true });
})();
